import { getParentGraphStep } from './getParentGraphStep.js';

export const getParentStepIds = (stepId, graph, ids = []) => {
  const parentStep = getParentGraphStep(stepId, graph);

  if (!parentStep) {
    return ids;
  }

  if (ids.includes(parentStep.id)) {
    console.log('Circular reference in getParentStepIds. Returning.');
    return ids;
  }

  if (parentStep.relation !== 'exit') {
    ids.push(parentStep.id);
  }

  return getParentStepIds(parentStep.id, graph, ids);
};
